import {useBrand} from '@/contexts/BrandContext';
import React from 'react';

export const BrandRoute = ({
  cortile,
  ark,
}: {
  cortile: React.ReactNode;
  ark: React.ReactNode;
}) => {
  const {key, resolved} = useBrand();
  return (
    <>
      {resolved && key === 'cortile' && cortile}
      {resolved && key === 'ark' && ark}
    </>
  );
};
